import * as React from 'react'
import { BookingCustomInput, BookingCustomInputSelectOption, BookingCustomInputType, BookingCustomInputTypeOptions } from '../../models/BookingCustomInput'
import { apiCallWrapper, Buttons, Col, ContainerWithPadding, FormFieldLabel, Grid, IdFormField, LabelFormField, nameof, NumberFormField, Row, SectionTitle, SelectFormFieldController, TextFormField, Tooltip } from 'traveldesk-ui'
import { Link } from 'react-router-dom'
import { set, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { ApplicationState } from '../../store'
interface Props {
    model: BookingCustomInput
    onSave: (model: BookingCustomInput) => void
    onCancel: () => void
}
const AdminBookingsCustomInputForm = (props: Props) => {
    const dispatch = useDispatch()
    const { register, handleSubmit,watch, setValue, formState: { errors }, control } = useForm({ defaultValues: props.model as any })
    const Localization = useSelector((state: ApplicationState) => state.localization.locale)
    const data = watch() as BookingCustomInput
    const type = data[nameof<BookingCustomInput>('type')]
    const save = async (data: BookingCustomInput) => {
        const response = await apiCallWrapper<BookingCustomInput>('/api/suppliers/custominputs', 'POST', dispatch, data)
        if(response.IsOk && response.Content){
            props.onSave(response.Content)
        }
        else {
            alert(response.ErrorMessage)
        }
    }
    const onSubmit = (data: BookingCustomInput) => {
        save(data)
    }
    return (
        <ContainerWithPadding>
            <Grid>
                <SectionTitle
                    title={props.model.id ? 'Edit Custom Input' : 'Add Custom Input'}
                />                
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Row style={{textAlign: 'left'}}>
                        <Col type="50">
                            <IdFormField control={control} />
                            <TextFormField
                                label="Name"
                                isRequired
                                subLabel='This name will be displayed to the user'
                                name={nameof<BookingCustomInput>('name')}
                                register={register}
                                options={{ required: 'Name is required' }}
                            />
                            <TextFormField
                                label="Description"
                                subLabel='This description will be displayed to the user'
                                name={nameof<BookingCustomInput>('description')}
                                register={register}
                                options={{ required: 'Description is required' }}
                            />
                            <SelectFormFieldController
                                control={control}
                                name={nameof<BookingCustomInput>('type')}
                                label="Type"
                                options={BookingCustomInputTypeOptions}                                
                            />
                        </Col>
                        <Col type="50">
                            {type === BookingCustomInputType.Number && (<>
                                <NumberFormField
                                        register={register}
                                        label={`${Localization.getString('Minimum value')}`}
                                        min={-9999999}
                                        max={99999999}
                                        step={0.01}
                                        name={nameof<BookingCustomInput>('minNumber')}
                                    />
                                    <i className='fa fa-times' onClick={() => setValue(nameof<BookingCustomInput>('minNumber'), undefined)} />
                                    <NumberFormField
                                        register={register}
                                        label={`${Localization.getString('Maximum value')}`}
                                        min={-9999999}
                                        max={99999999}
                                        step={0.01}
                                        name={nameof<BookingCustomInput>('maxNumber')}
                                    />
                                    <i className='fa fa-times' onClick={() => setValue(nameof<BookingCustomInput>('maxNumber'), undefined)} />
                            </>)}
                            {(type === BookingCustomInputType.Select || type === BookingCustomInputType.MultiSelect) && (<>
                                <FormFieldLabel label="Select Options" />                                
                                {(data.items || []).map((item: BookingCustomInputSelectOption, index: number) => (
                                    <Row key={index}>
                                        <Col type="50">
                                            <TextFormField
                                                label="Label"
                                                isRequired
                                                name={`items.${index}.label`}
                                                register={register}
                                            />
                                        </Col>
                                        <Col type="25">
                                            <i className='fa fa-times clickable float-right' onClick={() => setValue(`items.${index}.price`, null)} />
                                            <NumberFormField
                                                label="Price"
                                                name={`items.${index}.price`}
                                                register={register}
                                                step={0.01}
                                                min={0}
                                                max={99999999}                                                
                                            />                                            
                                        </Col>
                                        <Col type="25">
                                            <i className='fa fa-trash clickable' onClick={() => setValue(nameof<BookingCustomInput>('items'), data.items.filter((i: BookingCustomInputSelectOption) => i.guid !== item.guid))} />
                                        </Col>
                                    </Row>
                                ))}              
                                <hr/>                  
                                <Tooltip text={Localization.getString('Add option')}>
                                    <Buttons.ButtonSmallGreen onClick={() => setValue(nameof<BookingCustomInput>('items'), [...(data.items || []), new BookingCustomInputSelectOption()])}>
                                        <i className="fa fa-plus" />
                                    </Buttons.ButtonSmallGreen>
                                </Tooltip>
                            </>)}
                            
                        </Col>
                    </Row>
                    <Buttons.StickySaveButton>{Localization.getString('Save')}</Buttons.StickySaveButton>
                </form>
            </Grid>
        </ContainerWithPadding>
    )
}
export default AdminBookingsCustomInputForm